import SkeletonBox from "ui-kit/src/Skeleton/SkeletonBox"
import "./skeletons.css"

export function GamePageSkeleton() {
    return (
        <div className="gamePageSkeleton-container">
            <div className="gamePageSkeleton-header">
                <SkeletonBox className="header-left" />

                <SkeletonBox className="header-middle" />

                <SkeletonBox className="header-right" />
            </div>
            <SkeletonBox className="gamePageSkeleton-navBar" />
            <div className="gamePageSkeleton-content">
                <SkeletonBox className="gamePageSkeleton-video" />
                <SkeletonBox className="gamePageSkeleton-sidebar" />
            </div>
        </div>
    )
}